import React, { useEffect } from "react";
import Confetti from "react-confetti";
import { Outlet } from "react-router-dom";

import { Box, Grid } from "@mui/material";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { useDispatch, useSelector } from "@src/store";

import { setConfetti } from "../store/slices/global";

export const StandardNoPaddingPageProvider = () => {
  const confetti = useSelector((state) => state.global.confetti);
  const dispatch = useDispatch();

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (confetti) {
      timeout = setTimeout(() => dispatch(setConfetti(false)), 5000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [confetti, dispatch]);

  return (
    <Box
      id={"standard-no-padding-page-provider-box"}
      sx={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        // backgroundColor: "#F5F5F5",
        maxWidth: "none",
      }}
    >
      <NavigationDrawer isUnauthorized={false} />
      {confetti ? <Confetti gravity={0.15} recycle={false} /> : null}
      <Grid item sx={{ width: "-webkit-fill-available" }}>
        <Outlet />
      </Grid>
    </Box>
  );
};
